import Popper from '@mui/material/Popper';

export const PopperMy = function (props) {
    return <Popper {...props} style={{ maxWidth: 'fit-content' }} placement="bottom-start" />;
};
